import * as PIXI from "pixi.js";
import Tween from "tween.ts";
import Animation from "./Animation";


export default class SlideAnimation extends Animation{
  constructor(Container:PIXI.Container, offsetX:number, duration:number){
    super();
    new Tween.Tween(Container)
    .to({x:offsetX}, duration * 2)
    .easing(Tween.Easing.Linear.None)
    .start();
  }
}